import React from 'react';
import { Link } from 'react-router-dom';

type Props = {
  type: string,
  title: string,
  body: string,
  linkText: string,
  linkUrl: string,
  children: any,
  className: string
}

const PageMessage = (props: Props) => {
  return (
    <div className={`page-message ${props.type}`}>
      <h7 className='text-with-icon'>
        <i className='icon ic-check-green is-medium' />
        <span>{props.title}</span>
      </h7>
      <p className='icon-text'>{props.body} </p>
      {props.linkText && <Link to={props.linkUrl}>{props.linkText}</Link>}
      {props.children}
    </div>
  );
};

export default PageMessage;




// WEBPACK FOOTER //
// ./src/components/shared/PageMessage.js